import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-process',
  imports: [RouterLink],
  templateUrl: './process.html',
  styleUrl: './process.scss',
})
export class Process {}
